import React, {  useState,useEffect } from "react";
import "./OtcB.css";

function OtcB({leftSelection,rightSelection,handleNext,handlePrev}) { 
//state
const [leftChecked1, setleftChecked1] = useState(false);
const [leftChecked2, setleftChecked2] = useState(false);
const [leftChecked3, setleftChecked3] = useState(false);
const [rightChecked1, setrightChecked1] = useState(false);
const [rightChecked2, setrightChecked2] = useState(false);
const [rightChecked3, setrightChecked3] = useState(false);

const [leftPick, setLeftPick] = useState(leftSelection);
const [rightPick, setRightPick] = useState(rightSelection);

const HandleNextin =()=>{
  var data ={
    Oleft: leftPick,
    Oright: rightPick
  }
 handleNext(data)
 if((rightChecked1 && rightChecked2 && rightChecked3)){
 
  localStorage.setItem("ORightb",
  "BorderLine present")
 }else{
  
  localStorage.setItem("ORightb",
  "")}
 if((leftChecked1 && leftChecked2 && leftChecked3)){
  localStorage.setItem("OLeftb",
  "BorderLine present")
 }else{
  localStorage.setItem("OLeftb",
  "")}
}
const HandlePrevIn =()=>{
  var data ={
    Oleft: leftPick,
    Oright: rightPick
  }
  handlePrev(data)
  if((rightChecked1 && rightChecked2 && rightChecked3)){
    localStorage.setItem("ORightb",
    "BorderLine present")
   }else{
    localStorage.setItem("ORightb",
    "")}
   if((leftChecked1 && leftChecked2&& leftChecked3)){
    localStorage.setItem("OLeftb",
    "BorderLine present")
   }else{
    localStorage.setItem("OLeftb",
    "")}
  
}
useEffect(() => {
  if("O2" in leftPick ){
    if(0 in leftPick.O2){
     setleftChecked1(true)
    }
    if(1 in leftPick.O2){
      setleftChecked2(true)
    }
    if(2 in leftPick.O2){
      setleftChecked3(true)
    }

  }
  if("O2" in rightPick ){
    if(0 in rightPick.O2){
      setrightChecked1(true)
      }
      if(1 in rightPick.O2){
        setrightChecked2(true)
      }
      if(2 in rightPick.O2){
        setrightChecked3(true)
      }
  } 
});
const deleteKey =(obj,keym)=>{
  delete obj[keym]
  return obj
}
const handleChange=(which, pick, position)=>{
  if(which==="right"){  
    if(("O2" in rightPick) || Object.keys(rightPick).length===0){
      //add or remove it
      if("O2" in rightPick){
        var obk =  {...rightPick.O2}
       
        if(rightPick.O2[position] !== undefined){
          
          var obj = deleteKey(obk, position)
         if(position===0){
          setRightPick({O2: obj })
          setrightChecked1(false)
         }
         if(position===1){
          setRightPick({O2: obj })
          setrightChecked2(false)
         }
        
         if(position===2){
          setRightPick({O2: obj })
          setrightChecked3(false)
         }
         if(Object.keys(obj).length===0){
         
          setRightPick({})
         }
          }else{
            if(position===0){

              setRightPick({O2:{...rightPick.O2, 0:pick}}) 
              setrightChecked1(true)
             }
             if(position===1){
              setRightPick({O2:{...rightPick.O2, 1:pick}})
              setrightChecked2(true)
             }
             if(position===2){
              setRightPick({O2:{...rightPick.O2, 2:pick}})
              setrightChecked3(true)
             }
            
          }
        
      }
     if(Object.keys(rightPick).length===0){
      if(position===0){
        setRightPick({O2:{0:pick}});
        setrightChecked1(true)
       }
       if(position===1){
        setRightPick({O2:{1:pick}});
        setrightChecked2(true)
       }
       if(position===2){
        setRightPick({O2:{2:pick}});
        setrightChecked3(true)
       }
       
     }
    }
     if(!("O2" in rightPick )&& Object.keys(rightPick).length>0){
      alert("You already selected OCT")
    } 

  }
  if(which==="left"){
    
    if(("O2" in leftPick) || Object.keys(leftPick).length===0){
      //add or remove it
      if("O2" in leftPick){
        var obk =  {...leftPick.O2}
       
        if(leftPick.O2[position] !== undefined){
        
          var obj = deleteKey(obk, position)
         if(position===0){
          setLeftPick({O2: obj })
          setleftChecked1(false)
         }
         if(position===1){
          setLeftPick({O2: obj })
          setleftChecked2(false)
         }
         if(position===2){
          setLeftPick({O2: obj })
          setleftChecked3(false)
         }
         if(Object.keys(obj).length===0){
          
          setLeftPick({})
         }
          }else{
            if(position===0){

              setLeftPick({O2:{...leftPick.O2, 0:pick}}) 
              setleftChecked1(true)
             }
             if(position===1){
              setLeftPick({O2:{...leftPick.O2, 1:pick}})
              setleftChecked2(true)
             }
             if(position===2){
              setLeftPick({O2:{...leftPick.O2, 2:pick}})
              setleftChecked3(true)
             }
             
          }
        // setLeftPick({})
        // setleftChecked1(false)
      }
     if(Object.keys(leftPick).length===0){
      if(position===0){
        setLeftPick({O2:{0:pick}});
        setleftChecked1(true)
       }
       if(position===1){
        setLeftPick({O2:{1:pick}});
        setleftChecked2(true)
       }
       if(position===2){
        setLeftPick({O2:{2:pick}});
        setleftChecked3(true)
       }
       
     }
    }
     if(!("O2" in leftPick )&& Object.keys(leftPick).length>0){
      alert("You already selected OCT")
    } 
  }
  
}
    return (  
        <> 
         <div className="nav navbar-expand-lg sticky-top shadow text-center bg-warning" style={{marginBottom: "10px"}}> 
        <div className="container">
            <p className="display-6 text-dark text-center">
            <strong>OCT Borderline: All present </strong>
              </p>
          </div>
        </div>
        <div className="container">
          <div className="container">
            <div className="row">
            <div className="Image shadow col-xl-4 col-md-6">
          <img  className="HeaderSide img-fluid" style={{ height: "auto"}} src={require('../../assests/Images/otcb.png')} alt="retina" />
          <div className="Caption text-dark">
            <h5>Source: Kermany OCT dataset</h5>
          </div>
          </div>
          <div className="SideTable col-xl-8 col-md-6">
            <div className="container">
            <table className="shadow" style={{borderRadius: "10px", margin: "5px"}}>
              <tr className="bg-warning text-dark">
                <th className="text-dark">
                Criteria
                </th >
                <th className="text-dark">Right Eye
               (tick if present)</th>
               <th className="text-dark">Left Eye
               (tick if present)</th>
              </tr>
              <tr>
                <td className="text-dark"><strong>No OCT positive signs</strong></td>
                <td><form>
                <input type="checkbox" 
                value="NoBoardlineOTC"
                checked={rightChecked1}
                className="CheckBox" id="myCheckRight" 
                onChange={(e) =>
                  {handleChange("right",e.target.value,0)}
                 
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox"
                 value="NoBoardlineOTC"
                 checked={leftChecked1} className="CheckBox" id="myCheckleft" 
                 onChange={(e) =>
                  {handleChange("left",e.target.value,0)}
                  }/>
               
                  </form></td>
              </tr>
              <tr style={{backgroundColor: "#e9e9e9"}}>
                <td className="text-dark"><strong>{"Intraretinal cysts but no change in foveal contour and CRT < 250μm*"} </strong></td>
                <td><form>
                <input type="checkbox" 
                value="Intraretinal cysts but no change in foveal contour"
                checked={rightChecked2} 
                className="CheckBox" id="myCheckRight" 
                onChange={(e) => 
                  {handleChange("right",e.target.value,1)}
                  }/>
                    </form></td>
                <td><form>
                <input type="checkbox" 
                checked={leftChecked2}
                 className="CheckBox" id="myCheckleft" 
                 onChange={(e) => 
                  {handleChange("left",e.target.value,1)}}/>
               
                  </form></td>
              </tr>
              <tr>
            <td className="text-dark"><strong>{"Retinal thickening within the macula but <1 disc area"}</strong></td>
                <td><form>
                <input type="checkbox" 
                value="Retinal thickening within the macula but <1 disc area"
                checked={rightChecked3}  
                className="CheckBox" id="myCheckRight" 
                onChange={(e) => {handleChange("right",e.target.value,2)}
              }/>
                    </form></td>
                <td><form>
                <input type="checkbox" 
                 value="Retinal thickening within the macula but <1 disc area"
                 checked={leftChecked3} 
                 className="CheckBox" id="myCheckleft" 
                 onChange={(e) => 
                  {handleChange("left",e.target.value,2)}}/>
               
                  </form></td>
              </tr>
             
              
            </table>
            <div>
              <h5 className="text-danger"><strong>* Normal CRT differ depending on machine used, check reference values for your OCT</strong></h5>
              </div>
            <span ><span  className="RigthAnswer bg-primary text-light">Right eye:</span>
            <span className="AnswerDisplay">{(rightChecked1 && rightChecked2 && rightChecked3)?"BorderLine present":""}
            </span></span>
            <span><span  className="LeftAnswer bg-dark text-light">Left eye:&nbsp;&nbsp;&nbsp;</span>
            <span  className="AnswerDisplay">{(leftChecked1 && leftChecked2&& leftChecked3)?"BorderLine present":""}
            </span></span>
            </div>
           
          </div>
            </div>
          </div>
        </div>
        <br /><br />
          <div className="container">
            <div className="row">
            <div className="col-xl-4 col-md-6"></div>
            <div className="col-xl-4 col-md-6 text-center">

            
            <button className="btn btn btn-dark"
            onClick={()=>{HandlePrevIn()}}
            >Previous</button>&nbsp;
            <button className="btn btn btn-primary"
            onClick={()=>{HandleNextin()}}
            >Next</button>
            </div>
            <div className="col-xl-4 col-md-6"></div>
          </div>
          </div>
          <br /><br />
        </>
        
      );

    }


 
export default OtcB;